import AccountRegistrations from "./AccountRegistrations";
export default AccountRegistrations;
